// extracted by mini-css-extract-plugin
export default {"bio-pic":"about_bio-pic__L94yF","gallery-item":"about_gallery-item__FyYOE"};